import { z } from "zod";

export const WorkflowExecutionDurationPattern =
  /^(\d+)\s*(seconds?|secs?|sec|minutes?|mins?|min|hours?|hrs?|hr)?$/i;

export const WorkflowExecutionDurationSchema = z
  .string()
  .regex(
    WorkflowExecutionDurationPattern,
    "Use seconds, minutes, or hours, for example 60, 60 min, 90 sec, or 1 hr.",
  );

export const WorkflowStepRetryOverrideSchema = z.object({
  maximumAttempts: z.number().optional(),
  backoffCoefficient: z.number().optional(),
  initialInterval: WorkflowExecutionDurationSchema.optional(),
  maximumInterval: WorkflowExecutionDurationSchema.optional(),
});

export const WorkflowStepExecutionOverrideSchema = z.object({
  startToCloseTimeout: WorkflowExecutionDurationSchema.optional(),
  scheduleToCloseTimeout: WorkflowExecutionDurationSchema.optional(),
  heartbeatTimeout: WorkflowExecutionDurationSchema.optional(),
  retry: WorkflowStepRetryOverrideSchema.optional(),
  nonRetryableErrorTypes: z.array(z.string()).optional(),
});

export const WorkflowStepConfigExecutionOverrideSchema = z.object({
  execution: WorkflowStepExecutionOverrideSchema.optional(),
});

export type WorkflowStepExecutionOverride = z.infer<
  typeof WorkflowStepExecutionOverrideSchema
>;
